import React from 'react';
import { List, Datagrid, TextField } from 'react-admin';

const GrupoValidacionesList = (props) => (
  <List {...props} filter={{ deleted: false }}>
    <Datagrid rowClick="show">
      <TextField source="descripcion" />
    </Datagrid>
  </List>
);

export default GrupoValidacionesList;
